import { render, staticRenderFns } from "./DoubtsComponent.vue?vue&type=template&id=3c77d351&scoped=true&"
import script from "./DoubtsComponent.vue?vue&type=script&lang=js&"
export * from "./DoubtsComponent.vue?vue&type=script&lang=js&"
import style0 from "./DoubtsComponent.vue?vue&type=style&index=0&id=3c77d351&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77d351",
  null
  
)

export default component.exports